<template>
  <v-dialog v-model="show" fullscreen>
    <v-card>
      <v-card-title class="body-1">
        Public registration link settings
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="link.Title"
          label="Title"
          outlined
        ></v-text-field>
        <v-textarea
          v-model="link.Description"
          :label="'Description'"
          :placeholder="'Description'"
          outlined
          hide-details
          height="100"
        >
        </v-textarea>
        <v-col cols="12">
          <table style="width: 100%;">
            <thead>
              <tr>
                <th class="text-left">Included</th>
                <th class="text-left">Field</th>
                <th class="text-left">Required</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    class="form-control cb"
                    type="checkbox"
                    checked="checked"
                    :disabled="true"
                  />
                </td>
                <td>Phone number</td>
                <td>
                  <input
                    class="form-control cb"
                    type="checkbox"
                    checked="checked"
                    :disabled="true"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <input
                    v-model="link.IncludeCarNumber"
                    class="form-control cb"
                    type="checkbox"
                    @change="includeCarNumberChanged()"
                  />
                </td>
                <td>Car number</td>
                <td>
                  <input
                    v-model="link.CarNumberRequired"
                    class="form-control cb"
                    type="checkbox"
                    @change="carNumberRequiredChanged()"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <input
                    v-model="link.IncludeName"
                    class="form-control cb"
                    type="checkbox"
                    @change="includeNameChanged()"
                  />
                </td>
                <td>Name</td>
                <td>
                  <input
                    v-model="link.NameRequired"
                    class="form-control cb"
                    type="checkbox"
                    @change="nameRequiredChanged()"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <input
                    v-model="link.IncludeEmail"
                    class="form-control cb"
                    type="checkbox"
                    @change="includeEmailChanged()"
                  />
                </td>
                <td>Email</td>
                <td>
                  <input
                    v-model="link.EmailRequired"
                    class="form-control cb"
                    type="checkbox"
                    @change="emailRequiredChanged()"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <input
                    v-model="link.IncludeComments"
                    class="form-control cb"
                    type="checkbox"
                    @change="includeCommentsChanged()"
                  />
                </td>
                <td>Comments</td>
                <td>
                  <input
                    v-model="link.CommentsRequired"
                    class="form-control cb"
                    type="checkbox"
                    @change="commentsRequiredChanged()"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </v-col>
        <v-col>
          <v-row>
            <v-toolbar flat>
              <h4>Custom fields:</h4>
              <v-spacer></v-spacer>
              <v-btn small @click="addNewCustomField()">
                <span
                  class="glyphicon glyphicon-plus"
                  aria-hidden="true"
                ></span>
                Add new
              </v-btn>
            </v-toolbar>
          </v-row>

          <table style="width: 100%;">
            <thead>
              <tr>
                <th class="text-left">
                  Title
                </th>
                <th class="text-left">
                  Type
                </th>
                <th class="text-left">
                  Required
                </th>
                <th class="text-left">
                  Store to comments
                </th>
                <th></th>
              </tr>
            </thead>
            <!-- eslint-disable vue/no-use-v-if-with-v-for -->
            <tr
              v-for="customField in link.CustomFields"
              v-if="customField.Type !== 'SELECTION'"
              :key="customField.OrderInList"
            >
              <td>
                <v-text-field
                  v-model="customField.Title"
                  label="Title"
                  class="col-10 px-0"
                ></v-text-field>
              </td>
              <td>
                <v-select
                  v-model="customField.Type"
                  :items="[
                    { title: 'Free text', value: 'FREE_TEXT' },
                    { title: 'Selection', value: 'SELECTION' }
                  ]"
                  item-text="title"
                  item-value="value"
                  label="Type"
                ></v-select>
              </td>
              <td>
                <v-checkbox
                  v-model="customField.Required"
                  label="Required"
                  dense
                ></v-checkbox>
              </td>
              <td>
                <v-checkbox
                  v-model="customField.StoreValueToComments"
                  label="In comments field"
                  dense
                ></v-checkbox>
              </td>
              <td>
                <v-btn
                  v-show="customField.Type == 'SELECTION'"
                  small
                  outlined
                  class="mr-3"
                  @click="addNewCustomFieldSelectionValue(customField)"
                >
                  <v-icon small>mdi-plus</v-icon>
                  Add value
                </v-btn>
                <v-btn
                  color="error"
                  confirm
                  icon
                  small
                  @click="
                    deleteItemFromArray(link.CustomFields, customField)
                    deleteCustomField(customField)
                  "
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr v-else>
              <td colspan="6">
                <div>
                  <table
                    class="table table-condensed vmiddle"
                    style="margin-left: 20px;"
                  >
                    <tr
                      v-for="selectionValue in customField.SelectionValues"
                      :key="selectionValue.Id"
                    >
                      <td>
                        <input
                          v-model="selectionValue.Value"
                          type="text"
                          class="form-control"
                        />
                      </td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-default btn-sm"
                          confirm
                          @click="
                            deleteItemFromArray(
                              customField.SelectionValues,
                              selectionValue
                            )
                            deleteCustomFieldSelectionValue(selectionValue)
                          "
                        >
                          <span
                            class="glyphicon glyphicon-trash"
                            aria-hidden="true"
                          ></span>
                        </button>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
          </table>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="secondary--text">{{ $vuetify.lang.t('$vuetify.SAVE') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PublicLinkSettingsDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      link: {},
      customField: {}
    }
  },
  mounted() {
    this.$store.dispatch('campaigns/getLinkDetails', this.uuid).then(data => {
      this.link = data
    })
  },
  computed: {
    ...mapGetters('campaigns', ['campaign']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    includeCarNumberChanged() {
      if (!this.link.IncludeCarNumber) {
        this.link.CarNumberRequired = false
      }
    },
    carNumberRequiredChanged() {
      if (this.link.CarNumberRequired) {
        this.link.IncludeCarNumber = true
      }
    },
    includeNameChanged() {
      if (!this.link.IncludeName) {
        this.link.NameRequired = false
      }
    },
    nameRequiredChanged() {
      if (this.link.NameRequired) {
        this.link.IncludeName = true
      }
    },
    includeEmailChanged() {
      if (!this.link.IncludeEmail) {
        this.link.EmailRequired = false
      }
    },
    emailRequiredChanged() {
      if (this.link.EmailRequired) {
        this.link.IncludeEmail = true
      }
    },
    includeCommentsChanged() {
      if (!this.link.IncludeComments) {
        this.link.CommentsRequired = false
      }
    },
    commentsRequiredChanged() {
      if (this.link.CommentsRequired) {
        this.link.IncludeComments = true
      }
    },
    addNewCustomField() {
      if (this.link.CustomFields === null) {
        this.link.CustomFields = []
      }
      this.link.CustomFields.push({
        PublicLinkUuid: this.uuid,
        Type: 'FREE_TEXT',
        SelectionValues: [],
        OrderInList: this.link.CustomFields.length + 1
      })
    },
    addNewCustomFieldSelectionValue(customField) {
      customField.SelectionValues.push({
        PublicRegistrationLinkFieldId: customField.ID,
        OrderInList: customField.SelectionValues.length + 1
      })
    },
    deleteItemFromArray(array, item) {
      const index = array.indexOf(item)
      if (index > -1) {
        array.splice(index, 1)
      }
    }
  }
}
</script>

<style scoped>
.line-through {
  text-decoration: line-through;
}
</style>
